export const POWERED_BY = 'https://vikunja.io'
export const CALDAV_DOCS = 'https://vikunja.io/docs/caldav/'
